<template>
  <div ref="container">
    <div class="margin_top">
      <el-row style="background-color: #efecec">
        <el-col :span="4" style="text-align: left; position: sticky; top: 0">
          <div style="width: 1px; height: 1px"></div>
          <!-- <el-menu id="menuDiv" ref="menuDiv" :default-active="menuId" :default-openeds="['4', '5']"
            @select="handleSelect" @close="handleClose" background-color="#efecec" text-color="#505050"
            active-text-color="#000" :class="searchBarFixed ? 'isFixed' : ''"
            :style="{ bottom: bottomHeight > 0 ? bottomHeight + 'px' : 0 }" style="border: none; max-width: 200px;">
            <div v-for="menu in productList" :key="menu.id">
              <el-menu-item :index="menu.id">
                <span slot="title" :style="{ fontWeight: menu.id === '6' ? 'bold' : 'normal' }">{{ menu.title }}</span>
              </el-menu-item>

            </div>
          </el-menu> -->

          <div
            v-for="menu in productList"
            :key="menu.id"
            class="menu_wrapper"
            @click="menuId = menu.id"
            :style="{ background: menuId == menu.id ? '#b7b5b5' : '' }"
          >
            {{ menu.title }}
          </div>
        </el-col>
        <el-col :span="20" style="background-color: #ffffff">
          <div v-if="menuId == '0'">
            <div class="doc_title">GL-6-A智能安全帽使用说明书</div>
            <img
              v-for="item in 5"
              :key="item"
              :src="
                require('@/assets/img/documentation/GL-6-A智能安全帽使用说明书-' +
                  item +
                  '.jpg')
              "
              style="width: 960px"
              mode="scaleToFill"
            />
            <a
              :href="
                'https://app.gewuzhian.com/' + productList[menuId].download
              "
              target="_blank"
            >
              <div class="download-bt">
                <img
                  :src="require('@/assets/img/documentation/pdf.png')"
                  style="width: 30px; margin: 0 10px"
                />
                {{ productList[menuId].download }}
              </div>
            </a>
          </div>
          <div v-if="menuId == '1'">
            <div class="doc_title" style="font-size: 32px">平台操作说明</div>
            <img
              v-for="item in 15"
              :key="item"
              :src="
                require('@/assets/img/documentation/格物智安工地安全管理平台操作说明-' +
                  item +
                  '.jpg')
              "
              style="width: 960px"
              mode="scaleToFill"
            />
            <a
              :href="
                'https://app.gewuzhian.com/' + productList[menuId].download
              "
              target="_blank"
            >
              <div class="download-bt">
                <img
                  :src="require('@/assets/img/documentation/pdf.png')"
                  style="width: 30px; margin: 0 10px"
                />
                {{ productList[menuId].download }}
              </div>
            </a>
          </div>
          <div v-if="menuId == '2'">
            <div class="doc_title" style="font-size: 32px">
              GL-6-B定位基站使用说明书
            </div>
            <img
              :src="require('@/assets/img/documentation/基站使用说明书.png')"
              style="
                width: 960px;
                height: auto;
                object-fit: cover;
                object-position: 0 -50px;
              "
              mode="scaleToFill"
            />
            <div class="item-3-img"></div>
            <a
              :href="
                'https://app.gewuzhian.com/' + productList[menuId].download
              "
              target="_blank"
            >
              <div class="download-bt">
                <img
                  :src="require('@/assets/img/documentation/pdf.png')"
                  style="width: 30px; margin: 0 10px"
                />
                {{ productList[menuId].download }}
              </div>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      product: global.product,
      productList: [
        {
          id: "0",
          title: "智能安全帽使用说明书",
          download: "GL-6-A智能安全帽使用说明书.pdf",
        },
        {
          id: "1",
          title: "平台操作说明",
          download: "格物智安工地安全管理平台操作说明.pdf",
        },
        {
          id: "2",
          title: "基站使用说明书",
          download: "GL-6-B定位基站使用说明书.pdf",
        },
      ],
      menuId: "0",
      searchBarFixed: false,
      bottomHeight: 0,
      imgHeight: 525,
      imgwidth: 0,
      pageWidth: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      window.addEventListener("scroll", vm.handleScroll, false);
    });
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleScroll);
    next();
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    handleSelect(index) {
      this.menuId = index;
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const offsetTop = document.querySelector("#menuDiv").offsetTop;
      this.searchBarFixed = scrollTop > offsetTop + 640;

      // 能看到的页面的高度
      let windowHeight = window.innerHeight;
      // 监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let scrollHeight = this.$refs.container.scrollHeight;
      this.bottomHeight = scrollTop + windowHeight - scrollHeight - 110;
    },
    handleClose(key, keyPath) {
      this.$refs.menuDiv.open(keyPath);
    },
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
    },
  },
};
</script>

<style>
.h_title0 {
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  /* 让文字居中 */
}

.h_title {
  font-size: 3em;
  color: #000000;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  width: 480px;
}

.div_menu_title {
  background-color: #999999;
  padding: 0 20px;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

.el-icon-arrow-down:before {
  content: none;
}

.isFixed {
  position: fixed;
  top: 0;
  z-index: 999;
  overflow-y: auto;
}

.img_product {
  width: 960px;
}

.dic_detail_list {
  text-align: left;
  margin-top: 20px;
  background-color: #e5e5e5;
  padding: 20px 30px;
}

.div_detail_center {
  height: 304px;
  display: flex;
  align-items: center;
}

.img_index {
  position: relative;
  display: inline-block;
}

.download-bt {
  border: 1px solid #eaeaea;
  width: 320px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 13px;
  margin-left: 10px;
  cursor: pointer;
}

.menu_wrapper {
  height: 56px;
  font-size: 14px;
  text-align: center;
  line-height: 56px;
  cursor: pointer;
}

.menu_wrapper:hover {
  background: #d8d8d8;
}

.doc_title {
  font-size: 30px;
  font-weight: 600;
  text-align: left;
  margin-left: 100px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/views/documentation/documentation.vue